<!--@if (breadcrumbsToDisplay()) {-->
<!--  <div-->
<!--    class="flex gap-2 overflow-y-auto whitespace-nowrap py-2.5 text-sm"-->
<!--    itemscope-->
<!--    itemtype="https://schema.org/BreadcrumbList"-->
<!--  >-->
<!--    <div-->
<!--      *ngFor="let breadcrumb of breadcrumbsToDisplay(); let last = last; let index = index; trackBy: trackByFn"-->
<!--      class="flex gap-2"-->
<!--      itemprop="itemListElement"-->
<!--      itemscope-->
<!--      itemtype="https://schema.org/ListItem"-->
<!--    >-->
<!--      <ng-container *ngIf="last; else link">-->
<!--      <span class="text-grey-3"><span itemprop="name">{{ breadcrumb.anchor }}</span><span-->
<!--        *ngIf="breadcrumb.nameSuffix">{{ breadcrumb.nameSuffix }}</span></span>-->
<!--      </ng-container>-->
<!--      <ng-template #link>-->
<!--        <a-->
<!--          [queryParams]="breadcrumb.routeQueryParams"-->
<!--          [routerLink]="breadcrumb.routeParams"-->
<!--          class="hover:underline"-->
<!--          itemprop="item"-->
<!--        >-->
<!--          <span itemprop="name">{{ breadcrumb.anchor }}</span><span-->
<!--          *ngIf="breadcrumb.nameSuffix">{{ breadcrumb.nameSuffix }}</span>-->
<!--        </a>-->
<!--      </ng-template>-->
<!--      <meta content="{{ index + 1 }}" itemprop="position">-->
<!--      <span *ngIf="!last" class="inline-block text-grey-7"> &gt; </span>-->
<!--    </div>-->
<!--  </div>-->
<!--} @else {-->
<!--  <div class="h-2"></div>-->
<!--}-->



@if (breadcrumbsToDisplay(); as breadcrumbs) {
  <nav
    class="flex gap-2 overflow-y-auto whitespace-nowrap py-2.5 text-sm"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    @for (breadcrumb of breadcrumbs; track breadcrumb.anchor; let last = $last; let index = $index) {
      <div
        class="flex gap-2"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        @if (last) {
          <span class="text-grey-3" itemprop="name">
            {{ breadcrumb.anchor }}{{ breadcrumb.nameSuffix }}
          </span>
        } @else {
          <a
            [queryParams]="breadcrumb.routeQueryParams"
            [routerLink]="breadcrumb.routeParams"
            class="hover:underline"
            itemprop="item"
          >
            <span itemprop="name">{{ breadcrumb.anchor }}{{ breadcrumb.nameSuffix }}</span>
          </a>
          <span class="inline-block text-grey-7"> &gt; </span>
        }
        <meta [attr.content]="index + 1" itemprop="position">
      </div>
    }
  </nav>
} @else {
  <div class="h-2"></div>
}
